import React from "react";
export default function Service() {
  return (
   
<div className="services-page">

  <main className="main">

 
    <section id="services" className="services section">

   
      <div className="container section-title" data-aos="fade-up">
        <h2>Services</h2>
        <p>Transform your digital presence with comprehensive full stack development and cybersecurity solutions. Build secure, scalable applications that drive business growth and protect your digital assets.</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">

        <div className="row justify-content-center g-5">

          <div className="col-md-6" data-aos="fade-right" data-aos-delay="100">
            <div className="service-item">
              <div className="service-icon">
                <i className="bi bi-code-slash"></i>
              </div>
              <div className="service-content">
                <h3>Full Stack Development</h3>
                <p>End-to-end web application development using JHipster, React, and Spring Boot. Build scalable, responsive applications with modern architectures and best practices for optimal performance.</p>
                <a href="  " className="service-link">
                  <span>Learn More</span>
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-6" data-aos="fade-left" data-aos-delay="100">
            <div className="service-item">
              <div className="service-icon">
                <i className="bi bi-shield-lock"></i>
              </div>
              <div className="service-content">
                <h3>Cybersecurity Solutions</h3>
                <p>Comprehensive security assessments, vulnerability testing, and security implementation. Protect your applications from threats with robust security measures and compliance frameworks.</p>
                <a href="  " className="service-link">
                  <span>Learn More</span>
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-6" data-aos="fade-right" data-aos-delay="200">
            <div className="service-item">
              <div className="service-icon">
                <i className="bi bi-router-fill"></i>
              </div>
              <div className="service-content">
                <h3>Enterprise Network Infrastructure</h3>
                <p>Design, configure, and secure robust network infrastructures with professional-grade routers, switches, and firewalls. Implement security-hardened configurations, threat monitoring systems, and optimize network performance for enterprise environments.</p>
                <a href="#contact" className="service-link">
                  <span>Learn More</span>
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>

          

          <div className="col-md-6" data-aos="fade-left" data-aos-delay="200">
            <div className="service-item">
              <div className="service-icon">
                <i className="bi bi-database"></i>
              </div>
              <div className="service-content">
                <h3>Database Management</h3>
                <p>MySQL database design, optimization, and management. Ensure data integrity, performance, and security with well-structured database architectures and efficient query optimization.</p>
                <a href="  " className="service-link">
                  <span>Learn More</span>
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>

          
          <div className="col-md-6" data-aos="fade-left" data-aos-delay="300">
            <div className="service-item">
              <div className="service-icon">
                <i className="bi bi-headset"></i>
              </div>
              <div className="service-content">
                <h3>IT Support & Consulting</h3>
                <p>Comprehensive IT assistance, system administration, and technical consulting services. Get expert guidance on technology stack selection, architecture design, and implementation strategies.</p>
                <a href="  " className="service-link">
                  <span>Learn More</span>
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>



          <div className="col-md-6" data-aos="fade-right" data-aos-delay="300">
            <div className="service-item">
              <div className="service-icon">
                <i className="bi bi-palette-fill"></i>      
              </div>
              <div className="service-content">
                <h3>Creative Design & Social Media Management</h3>
                <p>Complete digital media solutions including professional graphic design, motion graphics, video editing, and strategic social media management. Specializing in growing online presence and monetizing platforms like X (Twitter), Instagram, and Facebook.</p>
                <a href="#contact" className="service-link">
                  <span>See Results</span>
                  <i className="bi bi-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>





          






        </div>

      </div>

    </section>

  </main>

</div>
  );
}